<template>
    <div id="appRoot">
        <template v-if="$route.meta.public || $route.fullPath =='/'">
            <transition>
                <keep-alive>
                    <v-app id="inspire" class="app">
                        <router-view :key="$route.fullPath"></router-view>
                    </v-app>
                </keep-alive>
            </transition>
        </template>
        <template v-else-if="$route.meta.nomenu">
            <v-app id="inspire" class="app">
                <app-toolbar class="app--toolbar" :has-menu="false"></app-toolbar>
                <v-content style="background: url('/p6/images/background.png');">
                    <!-- Page Header -->
                    <!--page-header></page-header-->
                    <div :class="pageClass">
                        <router-view :key="$route.fullPath"></router-view>
                    </div>
                    <!-- App Footer -->
                    <app-footer v-if="$route.meta.footer == true"/>

                </v-content>
                <!-- Go to top -->
                <app-fab></app-fab>
            </v-app>
        </template>
        <template v-else>
            <v-app id="inspire" class="app">
                <app-drawer class="app--drawer" v-if="$route.meta.nomenu==undefined || $route.meta.nomenu==null||$route.meta.nomenu==true"></app-drawer>
                <app-toolbar class="app--toolbar" :has-menu="true"></app-toolbar>
                <div class="errorHeader" v-if="!onLine">{{t("lang.common.offline")}}</div>
                <v-content>
                    <!-- Page Header -->
                    <!--page-header></page-header-->
                    <div :class="pageClass" style="margin-bottom: 150px">
                        <router-view :key="$route.fullPath"></router-view>
                    </div>
                    <!-- App Footer -->
                    <!--app-footer/-->
                </v-content>
                <!-- Go to top -->
                <app-fab></app-fab>
                <!--<v-btn
                  small
                  fab
                  dark
                  falt
                  fixed
                  top="top"
                  right="right"
                  class="setting-fab"
                  color="red"
                  @click="openThemeSettings"
                >
                  <v-icon>settings</v-icon>
                </v-btn>
                <v-navigation-drawer
                  class="setting-drawer"
                  temporary
                  right
                  v-model="rightDrawer"
                  hide-overlay
                  fixed
                >
                  <theme-settings></theme-settings>
                </v-navigation-drawer>-->
            </v-app>
        </template>
        <v-snackbar
                :timeout="30000"
                top
                :color="snackbar.color"
                v-model="snackbar.show"
        >
            {{ snackbar.text }}
            <v-btn dark flat @click.native="snackbar.show = false" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
    import AppDrawer from "@/components/AppDrawer";
    import AppToolbar from "@/components/AppToolbar";
    import AppFab from "@/components/AppFab";
    import PageHeader from "@/components/PageHeader";
    import ThemeSettings from "@/components/ThemeSettings";
    import AppFooter from "./components/layout/AppFooter";

    export default {
        components: {
            AppFooter,
            AppDrawer,
            AppToolbar,
            AppFab,
            PageHeader,
            ThemeSettings,
        },
        data: () => ({
            onLine: navigator.onLine ? true : false,
            expanded: true,
            rightDrawer: false
        }),

        watch: {
            onLine: function (val) {
                if (this.onLine === true) {
                    this.showBackOnline = true;
                    setTimeout(() => {
                        this.showBackOnline = false;
                    }, 1000);
                }
            },
        },

        computed: {
            snackbar: function () {
                return this.$store.state.alert;
            },

            pageClass() {
                if (this.$route.meta.footer == true) {
                    return "page-wrapper";
                } else {
                    return "page-wrapper-nofooter";

                }
            }
        },

        created() {
            window.getApp = this;

            //console.log(this.$route);
            //console.log(this.$route.meta);
            //debugger;

        },

        mounted() {
        },
        beforeDestroy() {
        },

        methods: {
            openThemeSettings() {
                this.$vuetify.goTo(0);
                this.rightDrawer = !this.rightDrawer;
            },
            updateOnlineStatus(e) {
                const {type} = e;
                this.onLine = type === 'online';
                console.log(this.onLine);
            }

        }
    };
</script>

<style lang="stylus" scoped>
    .setting-fab
        top: 50% !important;
        right: 0;
        border-radius: 0;

    .page-wrapper
        min-height: calc(100vh - 50px - 275px);

    .page-wrapper-nofooter
        min-height: calc(100vh - 50px);

</style>
